<div class="bg-jet-black-850 h-full overflow-y-auto flex flex-col">
  <p class="p-4 bg-jet-black-1000 font-bold text-white">{{'USERS.IMPORT.IMPORT_TO_TRAINING-ODEN' | translate}}</p>
  <div class="px-8 grid grid-cols-2 gap-1 border-t border-jet-black-700 text-white my-4 p-4">
    <oden-card class="main-color-content">
      <oden-card-content class="pt-0">
        <ion-row>
          <div>
            <p class="font-bold">{{'USERS.IMPORT.STEPS' | translate}}</p>
            <ol start="1">
              <li class="py-2 flex flex-shrink-0 items-center" *ngIf="!id_tipo_wod"><span
                  class="bg-white text-black rounded-full flex justify-center items-center w-4 h-4 flex-shrink-0 mx-1">1</span>
                  {{'USERS.IMPORT.DOWNLOAD_FILE' | translate}} <a class="text-primary-500 flex items-center"
                  href="https://storage.googleapis.com/oden-storage-prod/muestra-training.csv" target="_blanck">
                  “{{'USERS.IMPORT.SAMPLE' | translate}}”.
                  <ion-icon name="cloud-upload-outline" class="mx-1"></ion-icon>
                </a></li>
                 <li class="py-2 flex flex-shrink-0 items-center" *ngIf="id_tipo_wod"><span
                  class="bg-white text-black rounded-full flex justify-center items-center w-4 h-4 flex-shrink-0 mx-1">1</span>
                  {{'USERS.IMPORT.DOWNLOAD_FILE' | translate}} <a class="text-primary-500 flex items-center"
                  href="https://storage.googleapis.com/oden-storage-prod/training-example.csv" target="_blanck">
                  “{{'USERS.IMPORT.SAMPLE' | translate}}”.
                  <ion-icon name="cloud-upload-outline" class="mx-1"></ion-icon>
                </a></li>
              <li class="py-2 flex flex-shrink-0 items-center"><span
                  class="bg-white text-black rounded-full flex justify-center items-center w-4 h-4 flex-shrink-0 mx-1">2</span>
                  {{'USERS.IMPORT.FILL' | translate}}</li>
              <li class="py-2 flex flex-shrink-0 items-center"><span
                  class="bg-white text-black rounded-full flex justify-center items-center w-4 h-4 flex-shrink-0 mx-1">3</span>
                  {{'USERS.IMPORT.TRAINING_TYPES' | translate}}</li>
              <li class="py-2 flex flex-shrink-0 items-center"><span
                  class="bg-white text-black rounded-full flex justify-center items-center w-4 h-4 flex-shrink-0 mx-1">4</span>
                  {{'USERS.IMPORT.TRAINING_TYPES_2' | translate}}</li>
              <li class="py-2 flex flex-shrink-0 items-center"><span
                  class="bg-white text-black rounded-full flex justify-center items-center w-4 h-4 flex-shrink-0 mx-1">5</span>
                  {{'USERS.IMPORT.DONT_EXCED_TRAINING' | translate}}</li>
            </ol>
          </div>
          <p class="font-bold">{{'USERS.IMPORT.GOD_JOB' | translate}}</p>

        </ion-row>
      </oden-card-content>

    </oden-card>
    <div class="flex flex-col justify-between">
      <div>

        <p class="my-6">
          {{'USERS.IMPORT.MAKE_EASIER_TRAINING' | translate}}
        </p>
        <img *ngIf="!id_tipo_wod" src="assets/images/example-training.png" alt="">
        <img *ngIf="id_tipo_wod" src="assets/images/example-training-coach.png" alt="">
        <p class="italic font-bold my-6">{{'USERS.IMPORT.IMPORTANT' | translate}}
        </p>
        <p class="my-4">
          <label for="inputFile"
            class="rounded-sm bg-primary-500 text-black p-2 font-semibold mt-2 cursor-pointer">{{'USERS.SELECT_FILE_CSV' |
            translate}}</label>
          <input id="inputFile" (change)="readFile($event)" [formControl]="archivoCSV" type="file" class="hidden">
        </p>
      </div>

      <div class="flex justify-end dark:bg-jet-black-800 bg-jet-black-300 items-center p-2 mt rounded-sm">

        <oden-button class="mx-2" (click)="cerrar()" color="secondary" text="{{'GLOBAL.BUTTONS.SHUT_DOWN' | translate}}"></oden-button>
        <oden-button [disabled]="!archivoCSVFile" (click)="importarDatosCSV()" text="{{'USERS.IMPORT_FILE' | translate}}"></oden-button>
      </div>
    </div>

  </div>
  <div  class="overflow-y-auto h-full p-4">
    <h1 class="text-white">{{'GLOBAL.LABELS.RESULTS' | translate}}</h1>
    <ion-row *ngIf="resultadoImportacion != null">
      <h2 class=" text-orange-400">{{'USERS.IMPORT.NOT_REGISTERED' | translate}}</h2>
      <ion-col size="12" *ngFor="let incompletos of resultadoImportacion.incompletos " class="text-jet-black-200">
        {{incompletos.mensaje}} <span class=" text-red-600"> {{'GLOBAL.LABELS.ERRORS' | translate}}: </span>
        {{incompletos.errores}}
      </ion-col>
    </ion-row>
    <ion-row *ngIf="resultadoImportacion != null">
      <h2 class=" text-green-400">{{'USERS.IMPORT.REGISTERED' | translate}}</h2>
      <ion-col size="12" *ngFor="let registrados of resultadoImportacion.registrados " class="text-jet-black-200"> {{registrados.nombre
        }} {{registrados.apellido_paterno}} {{registrados.apellido_materno}}</ion-col>
    </ion-row>
  </div>
</div>